export class File {
    constructor(
        public id: number,
        public created_at: string,
        public updated_at: string,
        public key: string,
        public url: string,
        public name: string,
        public file_size: string,
        public mime_type: string,
        public expires_at: string
    ) { }
}

export class District {
    constructor(
        public id: number,
        public name: string,
        public province: string,
        public region: string,
        // public country: string,
        // public population: number,
    ) { }
}

export class Brand {
    public id: number = -1;
    public name: string = "";
}

export class Shop {
    public id: number = -1;
    public name: string = "";
    public furnitures: Furniture[] = []

    public latitude: string = "";
    public longitude: string = "";
    public address: string = "";
    public ubigeo: string = "";
    public chain_id: number = -1;
    public description: string = "";
    public promoter_id: number = -1;
    public promoter: any = {};
    public district?: District;
}

export class Furniture {
    public id: number = -1;
    public name: string = "";
    public description: string = "";
    public sku: string = "";

    public status: string = "EXHIBITED";
    public color: string = "BLACK";
    public height_cm: number = 100;
    public width_cm: number = 100;
    public levels: number = 1;
    public hooks: number = 7;
    public has_visual: boolean = true;

    public capacity: number = 120;
    public sides: number = 1;
    public wear_level: number = 1;

    public section_id: number = 1;
    public shop_id: number = 1;

    public brands?: Brand[];

    constructor(init?: Partial<Furniture>) {
        Object.assign(this, init);
    }

    // static fromJson(json: Map<string, any>): Furniture {
    //     let bi = new BusinessInfo(json["tax_name"], json["district_id"], json["district"], json["address"]);
    //     return bi;
    // };
    //
    valid(): boolean {
        let valid = this.sku.length > 0 && this.status.length > 0 && this.color.length > 0
        let valid2 = this.height_cm > 0 && this.width_cm > 0 && this.levels > 0 && this.hooks > 0
        let valid3 = this.sides > 0 && this.wear_level >= 0 && this.section_id > 0 && this.shop_id > 0
        // not checking: this.capacity and this.brands
        // We are spliting this in 3 to make debugging easier
        return valid && valid2 && valid3
    }
}

function FurntitureToURLParams(furniture: Furniture): URLSearchParams {

    let brands: string[] = []
    furniture.brands?.forEach((b) => {
        brands.push(b.id.toString())
    })

    let data: { [key: string]: string } = {
        "name": furniture.name ?? "",
        "description": furniture.description ?? "",
        "sku": furniture.sku ?? "",
        "status": furniture.status ?? "",
        "color": furniture.color ?? "",
        "height_cm": furniture.height_cm?.toString() ?? "",
        "width_cm": furniture.width_cm?.toString() ?? "",

        "levels": furniture.levels?.toString() ?? "",
        "hooks": furniture.hooks?.toString() ?? "",

        "has_visual": furniture.has_visual ? "true" : "false",
        "capacity": furniture.capacity?.toString() ?? "",

        "sides": furniture.sides?.toString() ?? "",
        "wear_level": furniture.wear_level?.toString() ?? "",
        "section_id": furniture.section_id?.toString() ?? "",
        "shop_id": furniture.shop_id?.toString() ?? "",
    };

    data["brand[]"] = brands


    return new URLSearchParams(data)
}


class WrappedJson {
    status: number = 0;
    data: Map<string, any> | null = null
    errors: Array<string> = []
    message: string = ""

    constructor(init?: Partial<WrappedJson>) {
        Object.assign(this, init);
    }
}

